module.exports = __webpack_public_path__ + "img/MTABAPPSPIRO.d0f8e0d4.svg";